document.addEventListener('DOMContentLoaded', () => {
	const root = document.querySelector('[data-bor-root]');
	if (!root) {
		return;
	}

	const apiEndpoint = window.borApi?.root || `${window.location.origin}/wp-json/bor/v1/entries`;
	const yearButtons = Array.from(root.querySelectorAll('[data-year]'));
	const entriesContainer = root.querySelector('[data-bor-entries]');
	const monthContainer = root.querySelector('[data-bor-months]');
	const monthWrapper = root.querySelector('[data-bor-month-wrap]');
	const yearContainer = root.querySelector('[data-bor-years]');
	const yearLabel = root.querySelector('[data-bor-year-label]');
	const searchInput = root.querySelector('[data-bor-search]');
	const searchButton = root.querySelector('[data-bor-search-btn]');
	const backButton = root.querySelector('[data-bor-back]');

	if (!yearButtons.length || !entriesContainer) {
		return;
	}

	let activeYear = null;
	let activeMonth = null;
	let searchTerm = '';
	let searchMode = false;
	let monthsCache = [];
	const MONTH_ORDER = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];

	const setMonthButtons = (months) => {
		if (!monthContainer) {
			return;
		}

		monthContainer.innerHTML = '';

		if (!months.length || !activeYear) {
			monthContainer.classList.add('is-hidden');
			monthWrapper?.classList.add('is-hidden');
			return;
		}

		monthWrapper?.classList.remove('is-hidden');
		monthContainer.classList.remove('is-hidden');

		months.forEach((month) => {
			const value = typeof month === 'string' ? month : month.slug;
			const label = typeof month === 'string' ? month : month.name;

			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'BOR__month-filter-item';
			button.dataset.month = value;
			button.setAttribute('role', 'tab');
			button.setAttribute('aria-selected', activeMonth === value ? 'true' : 'false');
			button.textContent = label;

			if (activeMonth === value) {
				button.classList.add('is-active');
			}

			button.addEventListener('click', () => {
				activeMonth = value;
				renderState();
				fetchEntries();
			});

			monthContainer.appendChild(button);
		});
	};

	const renderEntries = (entries) => {
		if (!entriesContainer) {
			return;
		}

		if (!entries.length) {
			entriesContainer.innerHTML = `<p class="BOR__empty">${window.borStrings?.noResults || 'No entries found.'}</p>`;
			return;
		}

		const html = entries
			.map(
				(entry) => `
        <article class="BOR__entry">
          <h2 class="BOR__entry-title">${entry.title}</h2>
          ${entry.date_of_death ? `<p class="BOR__entry-date-of-death">${entry.date_of_death}</p>` : ''}
        </article>
      `
			)
			.join('');

		entriesContainer.innerHTML = html;
	};

	const setLoading = () => {
		if (entriesContainer) {
			entriesContainer.innerHTML = `<p class="BOR__status">${window.borStrings?.loading || 'Loading...'}</p>`;
		}
	};

	const renderState = () => {
		if (searchMode) {
			yearContainer?.classList.add('is-hidden');
			monthContainer?.classList.add('is-hidden');
			monthWrapper?.classList.add('is-hidden');
			backButton?.classList.remove('is-hidden');
		} else {
			yearContainer?.classList.remove('is-hidden');
			backButton?.classList.add('is-hidden');
		}

		yearButtons.forEach((button) => {
			const isActive = button.dataset.year === activeYear;
			button.classList.toggle('is-active', isActive);
			button.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		if (yearLabel) {
			if (searchMode) {
				yearLabel.classList.add('is-hidden');
			} else {
				yearLabel.classList.remove('is-hidden');
			}
		}
	};

	const fetchEntries = async () => {
		if (!apiEndpoint) {
			return;
		}

		setLoading();
		const params = new URLSearchParams();
		if (activeYear) params.set('year', activeYear);
		if (activeMonth) params.set('month', activeMonth);
		if (searchTerm) params.set('search', searchTerm);

		try {
			const response = await fetch(`${apiEndpoint}?${params.toString()}`, {
				headers: {
					'X-WP-Nonce': window.borApi?.nonce || '',
				},
			});

			if (!response.ok) {
				throw new Error('Request failed');
			}

			const data = await response.json();
			const entries = Array.isArray(data.entries) ? data.entries : [];
			const months = Array.isArray(data.months) ? data.months : [];

			if (!activeMonth) {
				monthsCache = months;
			}
			renderEntries(entries);

			if (!searchMode) {
				setMonthButtons(monthsCache.length ? monthsCache : months);
				const monthButtons = Array.from(monthContainer?.querySelectorAll('[data-month]') || []);
				monthButtons.forEach((button) => {
					const isActive = button.dataset.month === activeMonth;
					button.classList.toggle('is-active', isActive);
					button.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});
			}
		} catch (error) {
			if (entriesContainer) {
				entriesContainer.innerHTML = `<p class="BOR__status">${window.borStrings?.error || 'Something went wrong. Please try again.'}</p>`;
			}
		}
	};

	yearButtons.forEach((button) => {
		button.addEventListener('click', () => {
			activeYear = button.dataset.year;
			activeMonth = null;
			searchMode = false;
			searchTerm = '';
			if (searchInput) {
				searchInput.value = '';
			}
			renderState();
			fetchEntries();
		});
	});

	if (searchInput) {
		searchInput.addEventListener('keydown', (event) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				searchButton?.click();
			}
		});
	}

	if (searchButton) {
		searchButton.addEventListener('click', () => {
			const term = searchInput ? searchInput.value.toLowerCase().trim() : '';
			if (!term) {
				return;
			}

			searchTerm = term;
			searchMode = true;
			activeYear = null;
			activeMonth = null;
			monthWrapper?.classList.add('is-hidden');
			renderState();
			fetchEntries();
		});
	}

	if (backButton) {
		backButton.addEventListener('click', () => {
			searchMode = false;
			searchTerm = '';
			activeYear = null;
			activeMonth = null;
			if (searchInput) {
				searchInput.value = '';
			}
			monthContainer?.classList.add('is-hidden');
			monthWrapper?.classList.add('is-hidden');
			monthContainer?.replaceChildren();
			entriesContainer.innerHTML = '';
			renderState();
		});
	}

	renderState();
});
